import SocialShare from '../social-share'
import { SocialShareWrapper, ButtonStyled } from './shareable-wish-list-share.styled'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useShareableWishListUrl } from '@bluheadless/ui-logic/src/hooks/wish-list/useShareableWishListUrl'
import Tooltip from '../../molecules/tooltip'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import Stack1Icon from '../../atoms/icons/stack-1-icon'

const ShareableWishListShare = ({ className }) => {
	const {
		wishList: { shareable },
	} = useConfig()

	const { url } = useShareableWishListUrl()
	const { formatMessage } = useIntl()
	const [open, setOpen] = useState(false)

	const handleCopyClipboard = ({ setMethod }) => {
		navigator.clipboard.writeText(url)
		setMethod(true)
		setTimeout(() => {
			setMethod(false)
		}, 1500)
	}

	return shareable && url ? (
		<SocialShareWrapper className={className}>
			<Tooltip
				PopperProps={{
					disablePortal: true,
					placement: 'top',
				}}
				open={open}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				title={formatMessage({ id: 'rewards_invitations_url_copied' })}
			>
				<ButtonStyled
					color="primary"
					variant="ghost"
					StartIcon={Stack1Icon}
					iconProps={{ fontSize: 'medium', sx: { transform: 'rotate(90deg)' } }}
					onClick={() => handleCopyClipboard({ setMethod: setOpen })}
				/>
			</Tooltip>
			<SocialShare url={url} />
		</SocialShareWrapper>
	) : null
}

export default ShareableWishListShare
